import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  reshipButton: {
    defaultMessage: 'Reship',
    description: 'Label for a button to reship a shipment',
    id: 'rCJeJ/',
  },
  reshipModalHeader: {
    defaultMessage: 'Reship',
    description: 'Header for a modal to confirm that the user wants to reship a shipment',
    id: 'vQTEY0',
  },
  reshipModalContentLine1: {
    defaultMessage:
      'A clone (Shipment #{orderNumber} - {shipmentNumber} of {shipmentCount}) will be created with the same shipping configurations and moved to Awaiting Shipment.',
    description: 'Text explaining what will happen when the user reships a shipment',
    id: '60GpQR',
  },
  reshipModalContentLine2: {
    defaultMessage: "This change will not affect the order's status on your store platform.",
    description: 'Text explaining what will happen when the user reships a shipment',
    id: 'Y/CEHM',
  },
  reshipModalErrorMessage: {
    defaultMessage: 'Failed to reship. Please try again.',
    description: 'Error message displayed when reshipping a shipment fails',
    id: 'Ox+ZA7',
  },
  bulkReshipSelectedShipments: {
    defaultMessage: 'You selected <b>{shipmentCount, plural, one {# shipment} other {# shipments}}</b> for reship.',
    description: 'Text showing the number of shipments the user has selected to reship',
    id: '1dofx7',
  },
  bulkReshipImportedAsShippedInfo: {
    defaultMessage: 'Shipments imported as Shipped will be moved to Awaiting Shipment.',
    description: 'Text explaining what happens when the user reships a shipment that was "imported as Shipped"',
    id: 'h536jJ',
  },
  bulkReshipShipmentInfo: {
    defaultMessage: 'Shipments shipped via ShipStation will be cloned and will be moved to Awaiting Shipment.',
    description: 'Text explaining what happens when the user reships a shipment that was shipped via the app',
    id: 'v27/Wy',
  },
  bulkReshipMarketplaceInfo: {
    defaultMessage: "This will not affect the order's status on your store platform.",
    description: 'Text explaining that reshipping a shipment will send updates to the marketplace/store',
    id: 'R0j7F+',
  },
  reshipSuccessNotificationTitle: {
    defaultMessage: 'Shipment Successfully Moved to Awaiting Shipment',
    description: 'Title for a notification to user that reship was successful',
    id: 'HvXch7',
  },
  reshipSuccessNotificationContent: {
    defaultMessage: 'Review the shipping configuration to re-process and reship the shipment.',
    description: 'Content for a notification to user that reship was successful',
    id: 'pSrnde',
  },
  reshipErrorNotificationTitle: {
    defaultMessage: 'Reship Error',
    description: 'Title for a notification to user that reship failed',
    id: 'boRVKx',
  },
  reshipErrorNotificationContent: {
    defaultMessage: 'There was an error reshipping your shipment. Please try again.',
    description: 'error restoring order content',
    id: 'ObKgBR',
  },
});
